// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27160%27 height=%27160%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27 opacity=%270.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);
    --reveal-duration: 0.9s;
  }

  html {
    scroll-behavior: smooth;
    /* Keeps anchored sections clear of the fixed header. */
    scroll-padding-top: 6rem;
  }

  body {
  --tw-bg-opacity: 1;
  background-color: rgb(243 236 227 / var(--tw-bg-opacity, 1));
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(15 15 16 / var(--tw-text-opacity, 1));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    /* Stops horizontal drift from parallax layers that overhang their frame. */
    overflow-x: hidden;
}

  ::selection {
  background-color: rgb(201 154 91 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(15 15 16 / var(--tw-text-opacity, 1));
}

  :focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(201 154 91 / var(--tw-ring-opacity, 1));
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #f3ece3;
}

  .on-dark :focus-visible {
  --tw-ring-offset-color: #0f0f10;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
  /* Every section shares one horizontal rhythm. */
  .shell {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1280px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
  @media (min-width: 640px) {

  .shell {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
  @media (min-width: 1024px) {

  .shell {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}

  /*
   * Hero height. \`svh\` is the small viewport height, so the frame does not
   * jump on mobile as the browser chrome collapses; \`vh\` stays as the
   * fallback for browsers without it.
   */
  .min-h-hero {
    min-height: 40rem;
  }

  @media (min-width: 1024px) {
    .min-h-hero {
      min-height: 100vh;
      min-height: 100svh;
    }
  }

  .eyebrow {
  font-family: Oswald, Impact, Haettenschweiler, sans-serif;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.28em;
}

  /* The short gold rule under headings. It draws itself in when revealed. */
  .rule {
  display: block;
  height: 2px;
  width: 3.5rem;
  transform-origin: left;
  --tw-bg-opacity: 1;
  background-color: rgb(201 154 91 / var(--tw-bg-opacity, 1));
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.bottom-8 {
  bottom: 2rem;
}
.top-0 {
  top: 0px;
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.-z-20 {
  z-index: -20;
}
.z-50 {
  z-index: 50;
}
.z-\\[60\\] {
  z-index: 60;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.-mt-3 {
  margin-top: -0.75rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[3\\/2\\] {
  aspect-ratio: 3/2;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-14 {
  height: 3.5rem;
}
.h-20 {
  height: 5rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[4\\.5rem\\] {
  height: 4.5rem;
}
.h-\\[88px\\] {
  height: 88px;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-\\[32rem\\] {
  max-height: 32rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-3 {
  width: 0.75rem;
}
.w-4 {
  width: 1rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[88px\\] {
  width: 88px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.origin-center {
  transform-origin: center;
}
.origin-left {
  transform-origin: left;
}
.-translate-x-4 {
  --tw-translate-x: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes kenburns {

  from {
    transform: scale(1.12);
  }

  to {
    transform: scale(1);
  }
}
.animate-kenburns {
  animation: kenburns 24s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
@keyframes scroll-cue {

  0% {
    transform: scaleY(0);
    transform-origin: top;
  }

  45% {
    transform: scaleY(1);
    transform-origin: top;
  }

  55% {
    transform: scaleY(1);
    transform-origin: bottom;
  }

  100% {
    transform: scaleY(0);
    transform-origin: bottom;
  }
}
.animate-scroll-cue {
  animation: scroll-cue 2.6s cubic-bezier(0.65, 0, 0.35, 1) infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-y-12 {
  row-gap: 3rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-ink\\/10 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(15 15 16 / 0.1);
}
.self-start {
  align-self: flex-start;
}
.overflow-hidden {
  overflow: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded-full {
  border-radius: 9999px;
}
.border {
  border-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-cream\\/10 {
  border-color: rgb(243 236 227 / 0.1);
}
.border-cream\\/15 {
  border-color: rgb(243 236 227 / 0.15);
}
.border-cream\\/30 {
  border-color: rgb(243 236 227 / 0.3);
}
.border-gold {
  --tw-border-opacity: 1;
  border-color: rgb(201 154 91 / var(--tw-border-opacity, 1));
}
.border-gold\\/40 {
  border-color: rgb(201 154 91 / 0.4);
}
.border-ink\\/10 {
  border-color: rgb(15 15 16 / 0.1);
}
.border-ink\\/15 {
  border-color: rgb(15 15 16 / 0.15);
}
.border-ink\\/20 {
  border-color: rgb(15 15 16 / 0.2);
}
.border-transparent {
  border-color: transparent;
}
.bg-cream {
  --tw-bg-opacity: 1;
  background-color: rgb(243 236 227 / var(--tw-bg-opacity, 1));
}
.bg-cream-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 228 217 / var(--tw-bg-opacity, 1));
}
.bg-cream\\/10 {
  background-color: rgb(243 236 227 / 0.1);
}
.bg-cream\\/15 {
  background-color: rgb(243 236 227 / 0.15);
}
.bg-cream\\/25 {
  background-color: rgb(243 236 227 / 0.25);
}
.bg-gold {
  --tw-bg-opacity: 1;
  background-color: rgb(201 154 91 / var(--tw-bg-opacity, 1));
}
.bg-gold-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(150 110 62 / var(--tw-bg-opacity, 1));
}
.bg-ink {
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 16 / var(--tw-bg-opacity, 1));
}
.bg-ink-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 22 26 / var(--tw-bg-opacity, 1));
}
.bg-ink-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 12 / var(--tw-bg-opacity, 1));
}
.bg-ink-900\\/35 {
  background-color: rgb(10 10 12 / 0.35);
}
.bg-ink-900\\/50 {
  background-color: rgb(10 10 12 / 0.5);
}
.bg-ink-900\\/80 {
  background-color: rgb(10 10 12 / 0.8);
}
.bg-ink-900\\/85 {
  background-color: rgb(10 10 12 / 0.85);
}
.bg-ink\\/25 {
  background-color: rgb(15 15 16 / 0.25);
}
.bg-ink\\/5 {
  background-color: rgb(15 15 16 / 0.05);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/75 {
  background-color: rgb(255 255 255 / 0.75);
}
.bg-\\[linear-gradient\\(90deg\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\.95\\)_0\\%\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\.86\\)_55\\%\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\.62\\)_100\\%\\)\\] {
  background-image: linear-gradient(90deg,rgba(10,10,12,0.95) 0%,rgba(10,10,12,0.86) 55%,rgba(10,10,12,0.62) 100%);
}
.bg-\\[radial-gradient\\(120\\%_100\\%_at_50\\%_50\\%\\2c transparent_35\\%\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\.55\\)_100\\%\\)\\] {
  background-image: radial-gradient(120% 100% at 50% 50%,transparent 35%,rgba(10,10,12,0.55) 100%);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-gold-700 {
  --tw-gradient-from: #8a5c31 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(138 92 49 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ink-900 {
  --tw-gradient-from: #0a0a0c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(10 10 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-ink-900\\/80 {
  --tw-gradient-from: rgb(10 10 12 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(10 10 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-gold {
  --tw-gradient-to: rgb(201 154 91 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #c99a5b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-gold-light {
  --tw-gradient-to: #dcb178 var(--tw-gradient-to-position);
}
.to-ink-900\\/50 {
  --tw-gradient-to: rgb(10 10 12 / 0.5) var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-\\[68\\%_center\\] {
  object-position: 68% center;
}
.object-left {
  object-position: left;
}
.p-2 {
  padding: 0.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pt-11 {
  padding-top: 2.75rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-36 {
  padding-top: 9rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-center {
  text-align: center;
}
.font-display {
  font-family: Oswald, Impact, Haettenschweiler, sans-serif;
}
.font-sans {
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
}
.font-serif {
  font-family: "Cormorant Garamond", Georgia, Times New Roman, serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[0\\.68rem\\] {
  font-size: 0.68rem;
}
.text-\\[0\\.78rem\\] {
  font-size: 0.78rem;
}
.text-\\[0\\.7rem\\] {
  font-size: 0.7rem;
}
.text-\\[0\\.98rem\\] {
  font-size: 0.98rem;
}
.text-\\[2\\.6rem\\] {
  font-size: 2.6rem;
}
.text-\\[2rem\\] {
  font-size: 2rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.not-italic {
  font-style: normal;
}
.leading-\\[0\\.98\\] {
  line-height: 0.98;
}
.leading-\\[1\\.06\\] {
  line-height: 1.06;
}
.leading-\\[1\\.08\\] {
  line-height: 1.08;
}
.leading-\\[1\\.55\\] {
  line-height: 1.55;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.tracking-\\[0\\.005em\\] {
  letter-spacing: 0.005em;
}
.tracking-\\[0\\.01em\\] {
  letter-spacing: 0.01em;
}
.tracking-\\[0\\.02em\\] {
  letter-spacing: 0.02em;
}
.tracking-\\[0\\.04em\\] {
  letter-spacing: 0.04em;
}
.tracking-\\[0\\.06em\\] {
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\] {
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.16em\\] {
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.1em\\] {
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.22em\\] {
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.24em\\] {
  letter-spacing: 0.24em;
}
.tracking-\\[0\\.26em\\] {
  letter-spacing: 0.26em;
}
.tracking-\\[0\\.3em\\] {
  letter-spacing: 0.3em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.text-cream {
  --tw-text-opacity: 1;
  color: rgb(243 236 227 / var(--tw-text-opacity, 1));
}
.text-cream\\/45 {
  color: rgb(243 236 227 / 0.45);
}
.text-cream\\/50 {
  color: rgb(243 236 227 / 0.5);
}
.text-cream\\/55 {
  color: rgb(243 236 227 / 0.55);
}
.text-cream\\/60 {
  color: rgb(243 236 227 / 0.6);
}
.text-cream\\/65 {
  color: rgb(243 236 227 / 0.65);
}
.text-cream\\/70 {
  color: rgb(243 236 227 / 0.7);
}
.text-cream\\/75 {
  color: rgb(243 236 227 / 0.75);
}
.text-cream\\/80 {
  color: rgb(243 236 227 / 0.8);
}
.text-cream\\/85 {
  color: rgb(243 236 227 / 0.85);
}
.text-cream\\/90 {
  color: rgb(243 236 227 / 0.9);
}
.text-gold {
  --tw-text-opacity: 1;
  color: rgb(201 154 91 / var(--tw-text-opacity, 1));
}
.text-gold-300 {
  --tw-text-opacity: 1;
  color: rgb(226 194 149 / var(--tw-text-opacity, 1));
}
.text-gold-700 {
  --tw-text-opacity: 1;
  color: rgb(138 92 49 / var(--tw-text-opacity, 1));
}
.text-gold\\/60 {
  color: rgb(201 154 91 / 0.6);
}
.text-ink {
  --tw-text-opacity: 1;
  color: rgb(15 15 16 / var(--tw-text-opacity, 1));
}
.text-ink\\/60 {
  color: rgb(15 15 16 / 0.6);
}
.text-ink\\/65 {
  color: rgb(15 15 16 / 0.65);
}
.text-ink\\/70 {
  color: rgb(15 15 16 / 0.7);
}
.text-ink\\/75 {
  color: rgb(15 15 16 / 0.75);
}
.text-ink\\/80 {
  color: rgb(15 15 16 / 0.8);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.line-through {
  text-decoration-line: line-through;
}
.decoration-cream\\/25 {
  text-decoration-color: rgb(243 236 227 / 0.25);
}
.decoration-1 {
  text-decoration-thickness: 1px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow-card {
  --tw-shadow: 0 1px 2px rgba(15, 15, 16, 0.03), 0 10px 30px -18px rgba(15, 15, 16, 0.22);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color), 0 10px 30px -18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.brightness-\\[0\\.97\\] {
  --tw-brightness: brightness(0.97);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_10px_24px_rgba\\(15\\2c 15\\2c 16\\2c 0\\.22\\)\\] {
  --tw-drop-shadow: drop-shadow(0 10px 24px rgba(15,15,16,0.22));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[3px\\] {
  --tw-backdrop-blur: blur(3px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-height\\2c opacity\\] {
  transition-property: max-height,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-\\[900ms\\] {
  transition-duration: 900ms;
}
.ease-out-expo {
  transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
}
.will-change-transform {
  will-change: transform;
}
  /*
   * Scroll reveals.
   *
   * Elements start displaced and settle when \`.is-in\` is added by the Reveal
   * component. Kept in CSS rather than JS so the browser can run the whole
   * thing on the compositor.
   */
  [data-reveal] {
    opacity: 0;
    transition:
      opacity var(--reveal-duration) var(--ease-out-expo),
      transform var(--reveal-duration) var(--ease-out-expo),
      clip-path var(--reveal-duration) var(--ease-out-expo);
  }

  [data-reveal='up'] {
    transform: translate3d(0, 28px, 0);
  }

  [data-reveal='left'] {
    transform: translate3d(-36px, 0, 0);
  }

  [data-reveal='right'] {
    transform: translate3d(36px, 0, 0);
  }

  [data-reveal='scale'] {
    transform: scale(0.94);
  }

  /* For imagery: the picture wipes upward inside its own frame. */
  [data-reveal='mask'] {
    opacity: 1;
    clip-path: inset(0 0 100% 0);
  }

  /* For the gold rules, which draw left-to-right. */
  [data-reveal='rule'] {
    opacity: 1;
    transform: scaleX(0);
  }

  [data-reveal].is-in {
    opacity: 1;
    transform: none;
    clip-path: inset(0 0 0 0);
  }

  /* Applies an incremental delay to children carrying \`--i\`. */
  .stagger > * {
    transition-delay: calc(var(--delay, 0ms) + var(--stagger, 70ms) * var(--i, 0));
  }

  /*
   * A faint film grain over dark sections. Large flat areas of near-black
   * band badly on ordinary displays; the noise breaks it up and reads as
   * printed stock rather than flat screen fill.
   */
  .grain::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    opacity: 0.4;
    mix-blend-mode: overlay;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  /* Nav and footer links: a hairline that grows from the centre. */
  .link-underline {
  position: relative;
}

  .link-underline::after {
    content: '';
    position: absolute;
    bottom: -0.25rem;
    left: 0px;
    height: 1px;
    width: 100%;
    transform-origin: center;
    --tw-scale-x: 0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    --tw-bg-opacity: 1;
    background-color: rgb(201 154 91 / var(--tw-bg-opacity, 1));
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 500ms;
    transition-timing-function: var(--ease-out-expo);
  }

  .link-underline:hover::after,
  .link-underline:focus-visible::after {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

/* Declared outside the layers so it is always emitted: the hero and the tab
   panel drive it from inline styles, where Tailwind cannot see the class. */
@keyframes fade-up {
  from {
    opacity: 0;
    transform: translate3d(0, 26px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  /* Reveals resolve immediately rather than never showing their content. */
  [data-reveal] {
    opacity: 1 !important;
    transform: none !important;
    clip-path: none !important;
  }

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.placeholder\\:text-cream\\/60::placeholder {
  color: rgb(243 236 227 / 0.6);
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:inset-0::before {
  content: var(--tw-content);
  inset: 0px;
}

.before\\:-z-10::before {
  content: var(--tw-content);
  z-index: -10;
}

.before\\:origin-left::before {
  content: var(--tw-content);
  transform-origin: left;
}

.before\\:scale-x-0::before {
  content: var(--tw-content);
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:bg-gold-600::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(150 110 62 / var(--tw-bg-opacity, 1));
}

.before\\:bg-gold-700::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(138 92 49 / var(--tw-bg-opacity, 1));
}

.before\\:bg-ink::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 16 / var(--tw-bg-opacity, 1));
}

.before\\:transition-transform::before {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:duration-500::before {
  content: var(--tw-content);
  transition-duration: 500ms;
}

.before\\:ease-out-expo::before {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.focus-within\\:border-gold:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(201 154 91 / var(--tw-border-opacity, 1));
}

.hover\\:-translate-y-1\\.5:hover {
  --tw-translate-y: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-gold:hover {
  --tw-border-opacity: 1;
  border-color: rgb(201 154 91 / var(--tw-border-opacity, 1));
}

.hover\\:border-gold-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(150 110 62 / var(--tw-border-opacity, 1));
}

.hover\\:border-ink:hover {
  --tw-border-opacity: 1;
  border-color: rgb(15 15 16 / var(--tw-border-opacity, 1));
}

.hover\\:bg-gold\\/\\[0\\.07\\]:hover {
  background-color: rgb(201 154 91 / 0.07);
}

.hover\\:text-cream:hover {
  --tw-text-opacity: 1;
  color: rgb(243 236 227 / var(--tw-text-opacity, 1));
}

.hover\\:text-gold:hover {
  --tw-text-opacity: 1;
  color: rgb(201 154 91 / var(--tw-text-opacity, 1));
}

.hover\\:text-gold-700:hover {
  --tw-text-opacity: 1;
  color: rgb(138 92 49 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:shadow-card-hover:hover {
  --tw-shadow: 0 2px 4px rgba(15, 15, 16, 0.05), 0 28px 56px -24px rgba(15, 15, 16, 0.32);
  --tw-shadow-colored: 0 2px 4px var(--tw-shadow-color), 0 28px 56px -24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:before\\:scale-x-100:hover::before {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.focus\\:not-sr-only:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.focus\\:fixed:focus {
  position: fixed;
}

.focus\\:left-4:focus {
  left: 1rem;
}

.focus\\:top-4:focus {
  top: 1rem;
}

.focus\\:z-\\[60\\]:focus {
  z-index: 60;
}

.focus\\:bg-gold-600:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(150 110 62 / var(--tw-bg-opacity, 1));
}

.focus\\:px-4:focus {
  padding-left: 1rem;
  padding-right: 1rem;
}

.focus\\:py-2:focus {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.focus\\:text-sm:focus {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.focus\\:text-white:focus {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}

.group:hover .group-hover\\:-translate-y-0\\.5 {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1\\.5 {
  --tw-translate-x: 0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.06\\] {
  --tw-scale-x: 1.06;
  --tw-scale-y: 1.06;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-x-100 {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-gold\\/40 {
  border-color: rgb(201 154 91 / 0.4);
}

.group:hover .group-hover\\:text-cream {
  --tw-text-opacity: 1;
  color: rgb(243 236 227 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-ink {
  --tw-text-opacity: 1;
  color: rgb(15 15 16 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:brightness-105 {
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

@media (min-width: 640px) {

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-11 {
    height: 2.75rem;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-11 {
    width: 2.75rem;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .sm\\:pb-28 {
    padding-bottom: 7rem;
  }

  .sm\\:pl-\\[3\\.5rem\\] {
    padding-left: 3.5rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-\\[1\\.05rem\\] {
    font-size: 1.05rem;
  }

  .sm\\:text-\\[1\\.6rem\\] {
    font-size: 1.6rem;
  }

  .sm\\:text-\\[1\\.75rem\\] {
    font-size: 1.75rem;
  }

  .sm\\:text-\\[1\\.7rem\\] {
    font-size: 1.7rem;
  }

  .sm\\:text-\\[2rem\\] {
    font-size: 2rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:leading-\\[1\\.55\\] {
    line-height: 1.55;
  }
}

@media (min-width: 1024px) {

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:max-w-2xl {
    max-width: 42rem;
  }

  .lg\\:max-w-md {
    max-width: 28rem;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 0\\.8fr\\)_minmax\\(0\\2c 1\\.2fr\\)\\] {
    grid-template-columns: minmax(0,0.8fr) minmax(0,1.2fr);
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 0\\.9fr\\)_minmax\\(0\\2c 1\\.1fr\\)\\] {
    grid-template-columns: minmax(0,0.9fr) minmax(0,1.1fr);
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-20 {
    gap: 5rem;
  }

  .lg\\:gap-y-0 {
    row-gap: 0px;
  }

  .lg\\:border-l {
    border-left-width: 1px;
  }

  .lg\\:border-ink\\/10 {
    border-color: rgb(15 15 16 / 0.1);
  }

  .lg\\:bg-\\[linear-gradient\\(90deg\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\.96\\)_0\\%\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\.88\\)_26\\%\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\.6\\)_44\\%\\2c rgba\\(10\\2c 10\\2c 12\\2c 0\\)_72\\%\\)\\] {
    background-image: linear-gradient(90deg,rgba(10,10,12,0.96) 0%,rgba(10,10,12,0.88) 26%,rgba(10,10,12,0.6) 44%,rgba(10,10,12,0) 72%);
  }

  .lg\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--tw-gradient-stops));
  }

  .lg\\:from-ink-900\\/40 {
    --tw-gradient-from: rgb(10 10 12 / 0.4) var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(10 10 12 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  }

  .lg\\:to-ink-900 {
    --tw-gradient-to: #0a0a0c var(--tw-gradient-to-position);
  }

  .lg\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:text-\\[2\\.5rem\\] {
    font-size: 2.5rem;
  }

  .lg\\:text-\\[3\\.25rem\\] {
    font-size: 3.25rem;
  }

  .lg\\:text-\\[3rem\\] {
    font-size: 3rem;
  }

  .lg\\:text-\\[4\\.5rem\\] {
    font-size: 4.5rem;
  }

  .lg\\:first\\:border-l-0:first-child {
    border-left-width: 0px;
  }
}

@media (min-width: 1280px) {

  .xl\\:gap-10 {
    gap: 2.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,0EAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,8CAAc;IAAd,uBAAc;EAAA;;EAAd;IAAA,uBAAc;IAAd,uDAAc;IAAd,wBAAc;EAAA;;EAAd;EAAA,kBAAc;EAAd,4DAAc;EAAd,0EAAc;EAAd,oBAAc;EAAd,gDAAc;EAAd,mCAAc;EAAd,kCAAc;IAAd,2EAAc;IAAd;AAAc;;EAAd;EAAA,uCAAc;EAAd,oBAAc;EAAd;AAAc;;EAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,oBAAc;EAAd,4DAAc;EAAd,2BAAc;EAAd;AAAc;;EAAd;EAAA;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;EAmClB,gDAAgD;EAE9C;EAAA,iBAAuD;EAAvD,kBAAuD;EAAvD,WAAuD;EAAvD,iBAAuD;EAAvD,qBAAuD;EAAvD;AAAuD;EAAvD;;EAAA;IAAA,kBAAuD;IAAvD;EAAuD;AAAA;EAAvD;;EAAA;IAAA,kBAAuD;IAAvD;EAAuD;AAAA;;EAGzD;;;;IAIE;EACF;IACE,iBAAiB;EACnB;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAGE;EAAA,yDAAmE;EAAnE,kBAAmE;EAAnE,iBAAmE;EAAnE,gBAAmE;EAAnE,yBAAmE;EAAnE;AAAmE;;EAGrE,0EAA0E;EAExE;EAAA,cAA6C;EAA7C,WAA6C;EAA7C,aAA6C;EAA7C,sBAA6C;EAA7C,kBAA6C;EAA7C;AAA6C;AA7DjD;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,oBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,oBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,oBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,oBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,+FAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;EA+EjB;;;;;;IAME;EACF;IACE,UAAU;IACV;;;2DAGuD;EACzD;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;EACxB;;EAEA,gEAAgE;EAChE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA,kDAAkD;EAClD;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,yBAAyB;EAC3B;;EAEA,6DAA6D;EAC7D;IACE,8EAA8E;EAChF;;EAEA;;;;IAIE;EACF;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,yDAAsU;EACxU;;EAEA,iEAAiE;EAE/D;EAAA;AAAe;;EAGjB;IACE,WAAW;IACX,kBAA8G;IAA9G,gBAA8G;IAA9G,SAA8G;IAA9G,WAA8G;IAA9G,WAA8G;IAA9G,wBAA8G;IAA9G,eAA8G;IAA9G,+LAA8G;IAA9G,kBAA8G;IAA9G,2DAA8G;IAA9G,8BAA8G;IAA9G,wDAA8G;IAA9G,0BAA8G;IAC9G,gDAAgD;EAClD;;EAIE;;EAAA,eAAkB;EAAlB;AAAkB;;AAjGtB;4EAC4E;AAC5E;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AA0FA;EACE;IACE,qBAAqB;EACvB;;EAEA,yEAAyE;EACzE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AA3LA;EAAA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA,eA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA,kBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA,kBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA,kBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA,8BA4LA;EA5LA,wDA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA,sBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,2BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,sBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,sBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,sBA4LA;EA5LA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA,oBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,oBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,oBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,oBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,uFA4LA;EA5LA,+FA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA,eA4LA;EA5LA;AA4LA;;AA5LA;EAAA,gBA4LA;EA5LA,WA4LA;EA5LA,YA4LA;EA5LA,UA4LA;EA5LA,SA4LA;EA5LA,iBA4LA;EA5LA,UA4LA;EA5LA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA,kBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,kBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,mBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,mBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,oBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,8BA4LA;EA5LA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA,2BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,yBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,0BA4LA;EA5LA;AA4LA;;AA5LA;EAAA,kBA4LA;EA5LA,kBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,iBA4LA;EA5LA,iBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,kBA4LA;EA5LA,kBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,eA4LA;EA5LA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA,oBA4LA;EA5LA;AA4LA;;AA5LA;EAAA,oBA4LA;EA5LA;AA4LA;;AA5LA;EAAA;AA4LA;;AA5LA;EAAA,iCA4LA;EA5LA;AA4LA;;AA5LA;;EAAA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA,oBA4LA;IA5LA;EA4LA;;EA5LA;IAAA,iBA4LA;IA5LA;EA4LA;;EA5LA;IAAA,iBA4LA;IA5LA;EA4LA;;EA5LA;IAAA,iBA4LA;IA5LA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA,iBA4LA;IA5LA;EA4LA;;EA5LA;IAAA,mBA4LA;IA5LA;EA4LA;;EA5LA;IAAA,kBA4LA;IA5LA;EA4LA;;EA5LA;IAAA,eA4LA;IA5LA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA,eA4LA;IA5LA;EA4LA;;EA5LA;IAAA,mBA4LA;IA5LA;EA4LA;;EA5LA;IAAA,kBA4LA;IA5LA;EA4LA;;EA5LA;IAAA;EA4LA;AAAA;;AA5LA;;EAAA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA,wEA4LA;IA5LA,kEA4LA;IA5LA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA,iBA4LA;IA5LA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;;EA5LA;IAAA;EA4LA;AAAA;;AA5LA;;EAAA;IAAA;EA4LA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  :root {\n    --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);\n    --reveal-duration: 0.9s;\n  }\n\n  html {\n    scroll-behavior: smooth;\n    /* Keeps anchored sections clear of the fixed header. */\n    scroll-padding-top: 6rem;\n  }\n\n  body {\n    @apply bg-cream font-sans text-ink antialiased;\n    /* Stops horizontal drift from parallax layers that overhang their frame. */\n    overflow-x: hidden;\n  }\n\n  ::selection {\n    @apply bg-gold/30 text-ink;\n  }\n\n  :focus-visible {\n    @apply outline-none ring-2 ring-gold ring-offset-2 ring-offset-cream;\n  }\n\n  .on-dark :focus-visible {\n    @apply ring-offset-ink;\n  }\n}\n\n@layer components {\n  /* Every section shares one horizontal rhythm. */\n  .shell {\n    @apply mx-auto w-full max-w-shell px-5 sm:px-8 lg:px-12;\n  }\n\n  /*\n   * Hero height. `svh` is the small viewport height, so the frame does not\n   * jump on mobile as the browser chrome collapses; `vh` stays as the\n   * fallback for browsers without it.\n   */\n  .min-h-hero {\n    min-height: 40rem;\n  }\n\n  @media (min-width: 1024px) {\n    .min-h-hero {\n      min-height: 100vh;\n      min-height: 100svh;\n    }\n  }\n\n  .eyebrow {\n    @apply font-display text-xs font-medium uppercase tracking-[0.28em];\n  }\n\n  /* The short gold rule under headings. It draws itself in when revealed. */\n  .rule {\n    @apply block h-[2px] w-14 origin-left bg-gold;\n  }\n}\n\n/* Declared outside the layers so it is always emitted: the hero and the tab\n   panel drive it from inline styles, where Tailwind cannot see the class. */\n@keyframes fade-up {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 26px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@layer utilities {\n  /*\n   * Scroll reveals.\n   *\n   * Elements start displaced and settle when `.is-in` is added by the Reveal\n   * component. Kept in CSS rather than JS so the browser can run the whole\n   * thing on the compositor.\n   */\n  [data-reveal] {\n    opacity: 0;\n    transition:\n      opacity var(--reveal-duration) var(--ease-out-expo),\n      transform var(--reveal-duration) var(--ease-out-expo),\n      clip-path var(--reveal-duration) var(--ease-out-expo);\n  }\n\n  [data-reveal='up'] {\n    transform: translate3d(0, 28px, 0);\n  }\n\n  [data-reveal='left'] {\n    transform: translate3d(-36px, 0, 0);\n  }\n\n  [data-reveal='right'] {\n    transform: translate3d(36px, 0, 0);\n  }\n\n  [data-reveal='scale'] {\n    transform: scale(0.94);\n  }\n\n  /* For imagery: the picture wipes upward inside its own frame. */\n  [data-reveal='mask'] {\n    opacity: 1;\n    clip-path: inset(0 0 100% 0);\n  }\n\n  /* For the gold rules, which draw left-to-right. */\n  [data-reveal='rule'] {\n    opacity: 1;\n    transform: scaleX(0);\n  }\n\n  [data-reveal].is-in {\n    opacity: 1;\n    transform: none;\n    clip-path: inset(0 0 0 0);\n  }\n\n  /* Applies an incremental delay to children carrying `--i`. */\n  .stagger > * {\n    transition-delay: calc(var(--delay, 0ms) + var(--stagger, 70ms) * var(--i, 0));\n  }\n\n  /*\n   * A faint film grain over dark sections. Large flat areas of near-black\n   * band badly on ordinary displays; the noise breaks it up and reads as\n   * printed stock rather than flat screen fill.\n   */\n  .grain::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: 0;\n    pointer-events: none;\n    opacity: 0.4;\n    mix-blend-mode: overlay;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\");\n  }\n\n  /* Nav and footer links: a hairline that grows from the centre. */\n  .link-underline {\n    @apply relative;\n  }\n\n  .link-underline::after {\n    content: '';\n    @apply absolute -bottom-1 left-0 h-px w-full origin-center scale-x-0 bg-gold transition-transform duration-500;\n    transition-timing-function: var(--ease-out-expo);\n  }\n\n  .link-underline:hover::after,\n  .link-underline:focus-visible::after {\n    @apply scale-x-100;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n\n  /* Reveals resolve immediately rather than never showing their content. */\n  [data-reveal] {\n    opacity: 1 !important;\n    transform: none !important;\n    clip-path: none !important;\n  }\n\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
